(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tada-contact-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const preselectInterest = () => {
      const interest = new URLSearchParams(window.location.search).get('interest');
      if (!interest) return;

      for (const select of document.querySelectorAll('select[data-tada-interest]')) {
        const match = [...select.options].find((option) => option.value.toLowerCase() === interest.toLowerCase());
        if (match) select.value = match.value;
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', preselectInterest);
    } else {
      preselectInterest();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
